import React from 'react';
import { IconButton, Input, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import styles from './NumberSpinner.module.scss';

interface PropsType {
  label?: string;
  value?: number;
  placeholder?: number;
  onUpdate: (newValue: number | undefined) => void;
  min?: number;
  max?: number;
}

const NumberSpinner = ({
  label,
  value,
  placeholder,
  onUpdate,
  min,
  max,
}: PropsType) => {
  return (
    <div className={styles.NumberSpinner}>
      {label && (
        <Typography
          fontSize="0.7em"
          textTransform="uppercase"
          color="primary"
          marginBottom="8px"
        >
          {label}
        </Typography>
      )}

      {/** TODO: Consider adding a delete button to clear the value */}

      <div className={styles.spinner}>
        <IconButton
          onClick={() => (value ? onUpdate(value - 1) : onUpdate(min || 0))}
          disabled={value ? min !== undefined && value <= min : false}
          color="primary"
          sx={{ borderRadius: 0 }}
        >
          <RemoveIcon />
        </IconButton>
        {/* TODO: Align number to vertical center correctly */}
        <Input
          type="number"
          value={value}
          placeholder={(placeholder && String(placeholder)) || ''}
          disableUnderline
          onChange={(e) => {
            if (e.target.value === '') {
              onUpdate(undefined);
              return;
            }

            const newValue = parseInt(e.target.value);

            if (!isNaN(newValue)) {
              // Check min and max only if defined
              if (
                (min === undefined || newValue >= min) &&
                (max === undefined || newValue <= max)
              ) {
                onUpdate(newValue);
              }
            }
          }}
          sx={{ width: '140px', fontWeight: 'bold' }}
          inputProps={{
            min: min,
            max: max,
          }}
          slotProps={{
            input: {
              min: min,
              max: max,
              size: 4,
              sx: {
                textAlign: 'center',
                // Disable default number input arrows
                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                  '-webkit-appearance': 'none',
                  margin: 0,
                },
                '&[type=number]': {
                  '-moz-appearance': 'textfield',
                },
              },
            },
          }}
        />
        <IconButton
          onClick={() => (value ? onUpdate(value + 1) : onUpdate(max || 0))}
          disabled={value ? max !== undefined && value >= max : false}
          color="primary"
          sx={{ borderRadius: 0 }}
        >
          <AddIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default NumberSpinner;
